import type { DataLayerEvent } from '../../../types'

import { ga4EventSchemas } from './event-schemas'

type Ga4EventName = keyof typeof ga4EventSchemas

export type Ga4ValidationIssue = {
  error_type: string
  field: string
  message: string
  expected?: string
  received?: unknown
}

export type Ga4ValidationErrors = {
  eventName: Ga4EventName
  issues: Ga4ValidationIssue[]
}

function isGa4EventName(eventName: unknown): eventName is Ga4EventName {
  return (
    typeof eventName === 'string' && Object.hasOwn(ga4EventSchemas, eventName)
  )
}

export function getValidationErrors(
  event: DataLayerEvent,
): Ga4ValidationErrors | undefined {
  const eventName = event.event

  if (!isGa4EventName(eventName)) {
    return undefined
  }

  const result = ga4EventSchemas[eventName].safeParse(event, {
    reportInput: true,
  })

  if (result.success) {
    return undefined
  }

  return {
    eventName,
    issues: result.error.issues.map((issue) => ({
      error_type: issue.code,
      field: issue.path.join('.'),
      message: issue.message,
      ...(issue.code === 'invalid_type'
        ? { expected: issue.expected, received: issue.input }
        : {}),
    })),
  }
}
